module.exports = __webpack_public_path__ + "static/media/polygon.fde7c705.svg";